// extracted by mini-css-extract-plugin
export default {"BlockSelection":"CO8NnFL3","title":"xAcf7ufl","list":"rqixsZKp","card":"apQ1fxon","active":"pkojC7Da","top":"vhIlyFWB","imgBox":"KppAUGsi","name":"hOF1ns4C","sum":"jv6Km4Y9","time":"wbmUpV6M","duties":"yYimIpB6","actionButton":"IceZlh9b","button":"nfxzVQqv","cardNotWork":"fzAtWTcb","notWork":"h09yixjn"};
    if(module.hot) {
      // 1734636562030
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  